import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-sitemap',
    styleUrls: ['./sitemap.page.scss'],
    templateUrl: './sitemap.page.html'
})
export class SitemapPage implements OnInit {
  constructor(
    private metaService: Meta,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Sitemap');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'Sitemap' }
    )
  }
}
